import React, { FC, useState } from 'react'
import { Trans, t } from '@lingui/macro'

import { TopicModelAsEditor } from 'front-end/src/graphql/private/PrivateSchemaTypes'

import { Upload } from '../../../../components/common/form/upload/Upload'
import { notification } from '../../../../components/common/notifications/Notifications'
import DrawerImage from '../../../../components/common/page/drawer/DrawerImage'
import {
  useRemoveTopicTitleImageMutation,
  useUploadTopicTitleImageMutation
} from './TopicCoverImage.codegen'
import { useTopicForEditQuery } from 'front-end/src/pages/topic-edit-page/TopicEditPage'
import IconPicture from '../../../../components/common/icon/IconPicture'
import {
  Spinner,
  DrawerItem,
  DrawerItemHeader,
  ButtonDanger
} from 'front-end/src/components'

export const TopicCoverImage: FC<{}> = () => {
  const {
    data,
    loading: topicLoading,
    refetch: refetchTopic
  } = useTopicForEditQuery()
  const topic = data?.topic as TopicModelAsEditor
  const [loading, setLoading] = useState(false)
  const draftVersion = topic?.draftVersion
  const img = draftVersion?.backgroundImage

  const [imageUrl, setImageUrl] = useState(img ? img.cdnUrl : null)
  const [removeTopicTitleImage] = useRemoveTopicTitleImageMutation()
  const [uploadTopicTitleImage] = useUploadTopicTitleImageMutation()

  if (topicLoading) {
    return <Spinner />
  }

  return (
    <DrawerItem>
      <DrawerItemHeader dataTest="CoverImageDrawer">
        <IconPicture />
        <Trans>Cover</Trans>
      </DrawerItemHeader>

      <DrawerImage imageUrl={imageUrl}>
        <ButtonDanger
          onClick={async () => {
            setLoading(true)

            const { data } = await removeTopicTitleImage({
              variables: {
                topicId: topic?.id
              }
            })
            if (
              data?.topic?.__typename === 'TopicModelAsEditor' &&
              data?.topic?.removeTopicTitleImage
            ) {
              refetchTopic()
              setImageUrl(null)
            } else {
              notification.error(t`Unable to remove image`)
            }
            setLoading(false)
          }}
        >
          <Trans>Remove image</Trans>
        </ButtonDanger>
      </DrawerImage>
      <Upload
        isFullWidth
        title={t`Choose image`}
        accept="image/png, image/jpeg, image/gif"
        isLoading={loading}
        onChange={(e) => {
          const files = e.currentTarget.files

          if (files && files.length) {
            setLoading(true)
            const file = files[0]
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = async (): Promise<void> => {
              const uploadFile = {
                name: file.name,
                data: reader.result as string
              }

              const { data } = await uploadTopicTitleImage({
                variables: {
                  topicId: topic?.id,
                  file: uploadFile
                }
              })
              if (
                data?.topic?.__typename === 'TopicModelAsEditor' &&
                data?.topic?.uploadTopicTitleImage
              ) {
                refetchTopic()
                setImageUrl(data?.topic?.uploadTopicTitleImage)
              } else {
                notification.error(t`Unable to upload image`)
              }
              setLoading(false)
            }
          }
        }}
      />
    </DrawerItem>
  )
}
